import { AdminCRUDFormValues} from '../../store/InitialStore';
import * as types from '../../actions/ActionTypes';
export default function AdminCRUDForm(state = AdminCRUDFormValues,action){
    const {type,payload} = action;
    switch(type){          
        case types.SET_ADMIN_FORM_PROFILE_PICTURE :
            return {
                ...state,
                profileImage : payload
            }     
        default:
            return state;
    }
}
